import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast.js';

const { addToast } = useToast();
const tagTypesUrl = '/api/tag_types';
const tagsUrl = '/api/tags';

export const getTopIndustries = async () => {
    try {
        const response = await axios.get(`${tagTypesUrl}/top-industries`);
        return response.data;
    } catch (error) {
        addToast(error.response?.data?.message || 'An error occurred','error');
    }
};

export const setTopIndustries = async (industries, topNumber) => {
    try {
        const response = await axios.post(`${tagTypesUrl}/top-industries`, { type_ids: industries, top_number: topNumber });
        return response.data;
    } catch (error) {
        addToast(error.response?.data?.message || 'An error occurred','error');
    }
};

export const getEvalTags = async () => {
    try {
        const response = await axios.get(`${tagsUrl}/eval-tags?hasLeaderboard=true`);
        return response.data;
    } catch (error) {
        addToast(error.response?.data?.message || 'An error occurred','error');
    }
};
